module.exports = __webpack_public_path__ + "media/resume_rev/resumeRev-resume-d87a50ec.jpg";